import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".masonry-column-wrap * {\n  break-inside: avoid;\n}";
styleInject(css_248z);

export { css_248z as default };
